import { render, staticRenderFns } from "./ThePasswordReset.vue?vue&type=template&id=3c1b0126&scoped=true&"
import script from "./ThePasswordReset.vue?vue&type=script&lang=js&"
export * from "./ThePasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./ThePasswordReset.vue?vue&type=style&index=0&id=3c1b0126&prod&lang=less&scoped=true&"
import style1 from "./ThePasswordReset.vue?vue&type=style&index=1&id=3c1b0126&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b0126",
  null
  
)

export default component.exports